import React from 'react';
import { Link } from 'react-router-dom';

const InlineError = ({ errorType = 401, message }) => {
  const getFixedMessage = (type) => {
    switch (type) {
      case 404:
        return "Запрашиваемая страница не существует или была удалена";
      case 502:
        return "Сервер не отвечает или произошла ошибка при обработке запроса.\nПопробуйте обновить страницу позже";
      default:
        return message || "Неизвестная ошибка";
    }
  };

  const getTitle = () => {
    switch (errorType) {
      case 404: return 'Страница не найдена';
      case 502: return 'Сервер недоступен';
      case 401: return 'Доступ запрещён';
      default: return 'Ошибка';
    }
  };

  const displayMessage = errorType === 401 ? message : getFixedMessage(errorType);

  return (
    <div className="page-container">
      <div className="not-found-container">
        <div className="not-found-content">
          <h2 className="changeableHeading">электронное голосование</h2>

          <div className="error-code">{errorType}</div>

          <h1>{getTitle()}</h1>
          <div className="not-found-message">
            {displayMessage}
          </div>

          <Link to="/" className="not-found-button">
            Вернуться на главную
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InlineError;